import { render, staticRenderFns } from "./ContentV.vue?vue&type=template&id=bf4cb1e8&scoped=true&"
import script from "./ContentV.vue?vue&type=script&lang=js&"
export * from "./ContentV.vue?vue&type=script&lang=js&"
import style0 from "./ContentV.vue?vue&type=style&index=0&id=bf4cb1e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4cb1e8",
  null
  
)

export default component.exports